export enum SystemControlType {
  SYSTEM,
  CCY_PAIR,
}

export namespace SystemControlType {
  let elements = [SystemControlType.SYSTEM, SystemControlType.CCY_PAIR];
  let alias = "com.bcdfx.model.SystemControlType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
